import { useAmount } from "../contexts/amountContext";
import InputField from "./InputField";

const RawMarket = () => {
  const { rowMarket, handleRowMarketChange } = useAmount();
  return (
    <div className="col text-center">
      <h1>Row Market</h1>

      <InputField
        lable="Anwar"
        id="anwar"
        name="anwar"
        value={rowMarket.anwar}
        onChange={handleRowMarketChange}
      />

      <InputField
        lable="Uthpol"
        id="uthpol"
        name="uthpol"
        value={rowMarket.uthpol}
        onChange={handleRowMarketChange}
      />

      <InputField
        lable="Najmul"
        id="najmul"
        name="najmul"
        value={rowMarket.najmul}
        onChange={handleRowMarketChange}
      />

      <InputField
        lable="Forhad"
        id="forhad"
        name="forhad"
        value={rowMarket.forhad}
        onChange={handleRowMarketChange}
      />

      <InputField
        lable="Harun"
        id="harun"
        name="harun"
        value={rowMarket.harun}
        onChange={handleRowMarketChange}
      />

      <InputField
        lable="Kaysar"
        id="kayser"
        name="kayser"
        value={rowMarket.kayser}
        onChange={handleRowMarketChange}
      />
    </div>
  );
};

export default RawMarket;
